import React,{ useState } from 'react'
import SliderWrapper from 'jd-library/SliderWrapper';
import InputWithMovingLabel from 'jd-library/InputWithMovingLabel';
import { connect } from 'react-redux';
import Button from 'jd-library/Button';
import {setVariantData, showVariantOptionsSlider, getVariantFlags, showEditVariantSlider,setVariantCorrection} from '../../../actions/variants';
import useOnScroll from 'jd-library/useOnScroll';
import styles from './variants.scss';
import toastMessageActions from 'jd-library/toastMessageActions';

const VariantOptions = (props) => {
    const [variantData, setVariantData] = useState({
        ...(props.mode == 'add' ? {type: props.keyType, options: ['']} : props.variantData[props.index])
    });
    const [scrolled, setScroll] = useState(false);
    const [scrollEl, setScrollEl] = useState(null);
    const [errorIndex, setErrorIndex] = useState(-1);
    const [optionOccurance,updateOccurance] = useState({});
    const nonEditableList = props.mode == 'edit-product' ? props.variantData[props.index]?.nonEditable : [];

    const addOption = () => {
        let countArr = [...props.variantData,{...variantData, options: [...variantData.options, ""]}]
        props.mode != 'add' && countArr.splice(props.index,1);
        const {noOfVariants} = getVariantFlags(countArr);
        let el = document.querySelector('.add-another');
        setTimeout(()=>{
            scrollEl.current.scrollTop = el.offsetTop;
        },500)
        if(noOfVariants > 300){
            props.showToastMessage({
				showToastMessage: true,
				message: 'Supports upto 300 Variants only',
				type: 'error',
				duration: 5000
            });
            return;
        }
        let tempObj = {...variantData};
        tempObj.options.push('');
        setVariantData(tempObj);
        handleVariantFieldUpdate(tempObj.options.length -1,'add');
    }

    const onSave = () => {
        let variantsArr = props.variantData
        let filteredOptions = variantData.options.filter(option => option.trim().length)
        if(!filteredOptions.length){
            //Show Error as per requirement for empty options list
            props.showToastMessage({
                showToastMessage: true,
                message: 'Please Enter Values in Options for '+variantData.type,
                type: 'info',
                duration: 5000
            });
            setErrorIndex(0);      
            return;
        }
        //Checking for duplicates
        let occurance = {};
        let isError = false;
        filteredOptions.map((item,index) => {
            item = item.trim();
            occurance[item] = {count: (occurance[item]?.count || 0) + 1,index: occurance[item]?.index || null};
            if(occurance[item].count > 1){
                if(!occurance[item].index) {
                    occurance[item]['index'] = index; 
                    isError = true;
                } 
            }
        })
        if(isError){
            props.showToastMessage({
                showToastMessage: true,
                message: 'Option Value Cannot be Same',
                type: 'info',
                duration: 5000
            });
            updateOccurance(occurance);
            return;
        }


        // for(let i=0;i<filteredOptions.length;i++){
        //     for(let j=0;j<filteredOptions.length;j++){
        //         if(i!=j && filteredOptions[i].toLowerCase().trim() == filteredOptions[j].toLowerCase().trim()){
        //             props.showToastMessage({
        //                 showToastMessage: true,
        //                 message: 'Option Value Cannot be Same',
        //                 type: 'info',
        //                 duration: 5000
        //             });
        //             setErrorIndex(j);
        //             return;
        //         }
        //     }
        // }
        if(props.mode == 'add'){
            const variantDataCopy = [...props.variantData];
            variantsArr.push({...variantData, options: filteredOptions.map(cur => cur.trim())});
            props.setVariantData(variantsArr);
            window.history.back();
            // window.history.back();   //for Dc
            setTimeout(()=>{
                if(props.from == 'homepage' && !variantDataCopy.length){
                    props.showEditVariantSlider(true)
                }
            }, 200)
        }else if(props.mode == 'edit-product'){
            variantsArr[props.index] = {...variantData, options: filteredOptions};
            props.setVariantData(variantsArr);
            window.history.back();
        }else{
            variantsArr[props.index] = {...variantData, options: filteredOptions};
            props.setVariantData(variantsArr);
            window.history.back();
        }
    }

    const handleVariantFieldUpdate = (index, mode = 'add') => {
        console.log(`🔁 Handling '${mode}' at index ${index}`);
      
        const variantCorrection = { ...props.variantCorrection };
      
        if (mode === 'add') {
          if (!variantCorrection[index]) {
            variantCorrection[index] = [];
            console.log(`✅ Created empty entry at index ${index}`);
          }
        }
      
        if (mode === 'delete') {
          if (variantCorrection[index]) {
            delete variantCorrection[index];
            console.log(`🧹 Deleted entire entry at index ${index}`);
          }
        }
      
        console.log("📦 Final variantCorrection =>", variantCorrection);
        props.setVariantCorrection(variantCorrection);
      };
      


    const deleteItem = (index, nonEditable) => {
        if(nonEditable){
            props.showToastMessage({
                showToastMessage: true,
                message: 'Pre-Created Variant Options Cannot be Deleted',
                type: 'info',
                duration: 5000
            });
            return;
        }
        setErrorIndex(-1);
        updateOccurance({});
        let tempArr = [...variantData.options]
        tempArr.splice(index,1);
        setVariantData({
            ...variantData,
            options: tempArr
        })
        props.showToastMessage({
            showToastMessage: true,
            message: `${variantData.type} Option Deleted`,
            type: 'info',
            duration: 5000
        });
        handleVariantFieldUpdate(index,'delete');
    }
    useOnScroll({
        callback : (e,scrollObj) => {
          if(scrollObj.currScroll.scrollTop){
            setScroll(true);
          }else{
             setScroll(false)
          }
        },
        element : !scrollEl ? null : scrollEl,
        deps: [scrollEl]
    })
    
    return (
        <SliderWrapper
            header={{
                heading: props.mode == 'add' ? 'Add Variant Options' : 'Edit Variant Options',
                raised: scrolled,
                rightIcons: []
            }}
            slider={{className: styles['variant-slider']}}
            onHidden={()=>{props.showVariantOptionsSlider({show: false})}}
            footer={{
                btnProps: [{
                    children: 'Continue',
                    clickHandler: onSave,
                    size: "lg",
                }]
            }}
            updateScrollContRef={(scrollref) => {
                setScrollEl(scrollref)
            }}
        >
            <div className={styles['slider-body'] +" vari-holder"}>
                <div className={styles['title-text']}>{props.mode == 'add' ? 'Add' : 'Edit'} Options for {variantData.type}</div>
                {variantData.options.map((item,index)=>{
                    const nonEditable = (props.mode == 'edit-product' && nonEditableList[index]) ? true : false;
                    return(
                        <div className={`${styles['input-holder']} ${styles['variant-option']} ${nonEditable ? 'non-editable' : ''}`}>
                            <InputWithMovingLabel 
                                label={`${variantData.type} Option ${variantData.options.length>1 ? Number(index+1) : ''}`}
                                errorMessage={(index == errorIndex || (optionOccurance[item.trim()]?.count > 1 && optionOccurance[item.trim()].index <= index)) ? variantData.options.filter(o => o.trim().length).length?'Option Value Cannot be Same':'Please Enter Values in Options for '+variantData.type : null}
                                input={{
                                    value: item,
                                    onChange: e => {
                                        let tempObj = {...variantData};
                                        tempObj.options = [...variantData.options]
                                        tempObj.options[index] = e.target.value;
                                        setVariantData(tempObj);
                                        setErrorIndex(-1);
                                        updateOccurance({})
                                    },
                                    onFocus: e =>{
                                        setErrorIndex(-1);
                                        updateOccurance({});
                                    },
                                    autoFocus: variantData.options.length == 1 && !nonEditable,
                                    readOnly: nonEditable,
                                    disabled: nonEditable
                                }}
                            />
                            {variantData.options.length>1 && <i onClick={()=>deleteItem(index, nonEditable)}className={`icon-trash ${styles['delete-option']} ${nonEditable ? styles['greyed-out'] : ''}`} />}
                        </div>
                    )
                })}
                <div className={styles['add-another']} onClick={addOption}><i className="icon-plus" /> <span>Add Another Option</span></div>
            </div>
        </SliderWrapper>
    )
}

const mapStateToProps = (state, props) => {
    return {
        ...props,
        variantData: state.variants.variantData,
        index: state.variants.variantOptionsSlider.index,
        keyType: state.variants.variantOptionsSlider.keyType,
        mode: state.variants.variantOptionsSlider.mode,
        from: state.variants.variantTypeSlider.from,
        productId: state.products.editProduct,
        variantCorrection: state.variants.variantCorrection
    }
}

export default connect(mapStateToProps,{
    setVariantData,
    showVariantOptionsSlider,
    showEditVariantSlider,
    setVariantCorrection,
    showToastMessage: toastMessageActions.showMessage
})(VariantOptions)